import { createSentryPiniaPlugin } from '@sentry/vue';
import { createPinia } from 'pinia';
import piniaPluginPersistedstate from 'pinia-plugin-persistedstate';

export default function pinia() {
  const pinia = createPinia();
  pinia.use(piniaPluginPersistedstate);
  pinia.use(createSentryPiniaPlugin());
  return pinia;
}
